module.exports = __webpack_public_path__ + "static/img/job_4.0585d71f.png";